import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
  HostListener,
  ElementRef,
  SimpleChanges
} from '@angular/core';
import { PostHelpers } from '@eview/core/domain/post/post.helpers';
import { environment } from '@eview/core';
import { Form } from '@eview/core/domain/form/form';
import { AppState } from '@eview/core/store/states/app.state';
import { selectForms } from '@eview/core/store/selectors/forms.selector';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';



@Component({
  selector: 'eview-card-slider',
  templateUrl: 'post-card-slider.component.html',
  styleUrls: ['post-card-slider.component.scss']
})
export class PostCardSliderComponent implements OnDestroy {
  @Input() public postList: any;
  @Input() private displayitem: any;
  @Input() private cardSliderTitle: string;
  @Output() public onClickViewDetail: EventEmitter<any> = new EventEmitter();

  PostHelpers = PostHelpers;
  format = environment.format;

  formsCatalog: Form[] = [];
  private formsSub: Subscription;

  constructor(private store: Store<AppState>) {}


  currentPage: number = 1;
  pagePosition = '0px';
  cardsPerPage: number;
  totalPages: number;
  overflowWidth: string;
  cardWidth: string = '450px';
  private readonly cardGapPx = 28;
  containerWidth: number;
  totalCards: number;
  sliderTitle: string;
  maxWidth: string;
  @ViewChild("container", { static: false, read: ElementRef })
  container: ElementRef;
  @HostListener("window:resize") windowResize() {
    // let newCardsPerPage = this.displayitem;
    // if (newCardsPerPage != this.cardsPerPage) {
      // this.cardsPerPage = newCardsPerPage;
      this.cardsPerPage = this.resolveCardsPerPage();
      this.initializeSlider();
      if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages;
        this.populatePagePosition();
      }
    // }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.totalCards = this.postList ? this.postList.length : 0;
    this.sliderTitle = this.cardSliderTitle;
    if (changes['postList']) {
      this.currentPage = 1;
    }
    this.cardsPerPage = this.resolveCardsPerPage();
    this.initializeSlider();
  }


  ngOnInit() {
    this.formsSub = this.store.select(selectForms).subscribe(forms => {
      this.formsCatalog = forms?.results ? [...forms.results] : [];
    });
    this.totalCards = this.postList ? this.postList.length : 0;
    this.sliderTitle = this.cardSliderTitle;
    this.cardsPerPage = this.resolveCardsPerPage();
    this.initializeSlider();
  }

  ngOnDestroy() {
    this.formsSub?.unsubscribe();
  }
  initializeSlider() {
    const cardWidthPx = this.genCardsWidth();
    this.cardWidth = `${cardWidthPx}px`;
    this.cardsPerPage = this.resolveCardsPerPage();
    this.totalPages =
      this.totalCards > 0
        ? Math.ceil(this.totalCards / this.cardsPerPage)
        : 0;
    const trackWidth =
      this.totalCards * cardWidthPx +
      Math.max(0, this.totalCards - 1) * this.cardGapPx;
    this.overflowWidth = `${trackWidth}px`;
    this.maxWidth = 'calc(100vw - 0px)';
    if (this.totalPages > 0 && this.currentPage > this.totalPages) {
      this.currentPage = this.totalPages;
    }
    this.populatePagePosition();
  }

  resolveCardsPerPage(): number {
    const configured =
      this.displayitem > 0 ? Math.floor(this.displayitem) : null;
    const calculated = Math.max(1, Math.floor(this.genCardsPerPage()));
    return configured ?? calculated;
  }

  genCardsWidth() {
    const screenWidth = window.innerWidth;
    let cardWidth = 450;

    if (screenWidth < 900 && screenWidth >= 560) {
      cardWidth = 400;
    } else if (screenWidth < 560 && screenWidth >= 400) {
      cardWidth = 350;
    } else {
      cardWidth = 300;
    }

    return cardWidth;
  }

  genCardsPerPage() {
    const screenWidth = window.innerWidth;
    const cardWidth = this.genCardsWidth()
    return (screenWidth * 0.8) / cardWidth
  }
  changePage(incrementor) {
    this.currentPage += incrementor;
    this.populatePagePosition();
  }


  populatePagePosition() {
    const cardWidthPx = this.genCardsWidth();
    const pageStep = this.cardsPerPage * (cardWidthPx + this.cardGapPx);
    const offset = (this.currentPage - 1) * pageStep;
    this.pagePosition = `-${offset}px`;
  }

  trackNgStyle(): Record<string, string> {
    return {
      width: this.overflowWidth,
      transform: `translateX(${this.pagePosition})`
    };
  }

  /** Ancho fijo: el texto largo no debe ensanchar el carrusel. */
  cardNgStyle(): Record<string, string> {
    return {
      width: this.cardWidth,
      maxWidth: this.cardWidth,
      minWidth: this.cardWidth,
      flex: `0 0 ${this.cardWidth}`
    };
  }

  managementLevels(post) {
    return PostHelpers.FormatMgmtLevels(post);
  }
}
